import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { SiteState } from '@stores/site';

@Component({
  selector: 'tr-loading',
  imports: [CommonModule],
  templateUrl: './Loading.component.html',
  styleUrl: './Loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent {
  private store = inject(Store);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  constructor() {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/';

    this.store.select(SiteState.isInitalized).subscribe((initialized) => {
      if (initialized) {
        this.router.navigate([returnUrl]);
      }
    });
  }
}
